import React, { useEffect, useState } from "react";
import "./styles.scss";
import { useAuth, useFirestore } from "reactfire";
import image1 from "../../../../../../../../../shared/resources/generic-user-profile-image.png";
import { useAppUser } from "../../../../../../../../../contexts/user-context/UserContext";
import ForumUtils from "../../../../../../../../../shared/utils/ForumUtils";

const ProfileInfo = () => {
  const auth = useAuth();
  const appUser = useAppUser();
  const [proPic, setProPic] = useState(appUser.photoURL);
  const store = useFirestore();

  const logOut = () => {
    auth
      .signOut()
      .then((res) => {
        localStorage.setItem("isAuthed", "false");
        sessionStorage.setItem("isAuthed", "false");
        ForumUtils.clearForumData();
      })
      .catch((err) => {
        console.log(err);
      })
      .finally(() => {
        document.location.reload();
      });
  };

  useEffect(() => {
    if (appUser.fireUser) {
      const unset1 = store
        .collection("users")
        .where("uid", "==", appUser.fireUser?.uid)
        .onSnapshot({}, (snapshot) => {
          snapshot.docChanges().forEach((change) => {
            if (change.type === "added" || change.type === "modified") {
              setProPic((ps) => {
                const userData: any = change.doc.data();
                return userData.photoURL;
              });
            }
            if (change.type === "removed") {
              setProPic((prevState) => {
                return image1;
              });
            }
          });
        });

      return () => {
        unset1();
      };
    }
  }, [store, appUser.fireUser]);

  return (
    <div className="profile-infor-wrapper">
      <div className="profile-image-wrapper">
        <img src={proPic || image1} alt="" />
      </div>
      <div className="username-wrapper">
        <label>{appUser.displayName}</label>
      </div>
      <div className="logout-button-wrapper">
        <button className="logout-button" onClick={logOut}>
          Logout
        </button>
      </div>
    </div>
  );
};

export default ProfileInfo;
